<template>
  <div class="content-wrapper">

    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="pageTitle"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
    </div>

    <div v-if="this.active != 1" class="mb-2">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-if="this.active < 3"> <a href="" @click.prevent="previous">List</a></el-breadcrumb-item>
        <el-breadcrumb-item>Profile</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-form v-if="active === 1">
      <!-- <app-table :options="options" @action="getListAction" /> -->
      <app-table
        :id="tableId"
        :options="options"
        :card-view="true"
        @action="getListAction"
      />
    </el-form>

    <el-form v-if="active === 2">
      <my-profile :id="userId" :remove="classRemove"></my-profile>
    </el-form>
    <!-- <supplier-formmodal
      v-if="isFormModalActive"
      :id="userId"
      :table-id="tableId"
      @close-modal="closeFormModal"
    /> -->
  </div>
</template>
<script>
import CoreLibrary from "../../../../../../core/helpers/CoreLibrary";
import * as actions from "../../../../../Config/ApiUrl";
import { TableHelpers } from "../../../Demo/Tables/mixins/TableHelpers";
import AppFunction from "../../../../../../core/helpers/app/AppFunction";
import { axiosGet } from "../../../../../Helpers/AxiosHelper";

export default {
  extends: CoreLibrary,
  name: "GridView",
  mixins: [TableHelpers],
  data() {
    return {
      pageTitle: '',
      classRemove: true,
      active: 1,
      userId: 0,
      isFormModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      tableId: "grid-view-table",
      rowData: {},
      options: {
        cardView: true,
        cardViewComponent: "allsupplier-index-grid",
        name: "AdvanceTable",
        url: actions.SHORT_LIST_USER,
        showHeader: true,
        columns: [
          // {
          //   title: this.$t("name"),
          //   type: "media-object",
          //   key: "media-object",
          //   mediaTitleKey: "full_name",
          //   mediaSubtitleKey: "email",
          //   default: AppFunction.getAppUrl("images/avatar-demo.jpg"),
          //   modifier: (value, row) => {
          //     return value; // imag url
          //   },
          //   isVisible: true,
          // },
            {
              title: this.$t("company_name"),
              type: "custom-html",
              key: "company",
              modifier: (value, row) => {
                return `<a href="#" id="${row.id}" @click=${this.myFunction(row.id)}>${this.$t(value.company_name)}</a>`;
              },
            },
            {
              title: this.$t("start_date"),
              type: "custom-html",
              key: "company",
              modifier: (value) => {
                return `<span>${this.$t((value.start_date)?value.start_date:'---')}</span>`;
              },
            },
            {
              title: this.$t("end_date"),
              type: "custom-html",
              key: "company",
              modifier: (value) => {
                return `<span>${this.$t((value.end_date)?value.end_date:'---')}</span>`;
              },
            },
            {
              title: this.$t("is_verify_lable"),
              type: "custom-html",
              key: "company",
              isVisible: true,
              modifier: (value) => {
                console.log(value.is_verify);
                if (value.is_verify){
                  return `<span class="badge badge-sm badge-pill badge-success">${this.$t('Verfied')}</span>`;
                }else{
                  return `<span class="badge badge-sm badge-pill badge-warning">${this.$t('Unverified')}</span>`;
                }

              },
            },
          // {
          //   title: this.$t("phone"),
          //   type: "custom-html",
          //   key: "phone",
          //   modifier: (value) => {
          //     return `<span>${this.$t(value ?? '---')}</span>`;
          //   },
          // },
          //   {
          //     title: this.$t("amount"),
          //     type: "custom-html",
          //     key: "gender",
          //     modifier: (value) => {
          //       return `<span>${this.$t(value)}</span>`;
          //     },
          //   },
        ],
        actions: [
          {
            title: this.$t("shortlist"),
            icon: "edit",
            type: "none",
            // component: "app-add-modal",
            // modalId: "demo-add-edit-Modal",
          },
          {
            title: this.$t("view_profile"),
            icon: "eye",
            type: "none",
          },
        ],
        filters: [
          // {
          //   title: this.$t("date"),
          //   type: "range-picker",
          //   key: "date",
          //   option: ["today", "thisMonth", "last7Days", "nextYear"],
          // },
          // {
          //   title: this.$t("age"),
          //   type: "range-filter",
          //   key: "age-range",
          //   maxTitle: this.$t("max_age"),
          //   minTitle: this.$t("min_age"),
          //   sign: "",
          // },
          // {
          //   title: this.$t("status"),
          //   type: "checkbox",
          //   key: "status",
          //   option: [
          //     { id: "active", value: "Active" },
          //     { id: "inactive", value: "Inactive" },
          //     { id: "invited", value: "Invited" },
          //   ],
          // },
          {
            title: this.$t("is_verify_lable"),
            type: "radio",
            key: "is_verify",
            option: [
              { id: "1", value: "Verified" },
              { id: "0", value: "Unverified" },
            ],
            header: {
              title: this.$t("want_to_filter_supplier_by_status"),
              description: this.$t(
                "select_company_status"
              ),
            },
          },
          {
            title: this.$t("search_and_select"),
            type: "drop-down-filter",
            key: "search select",
            option: [],
          },
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        // showAction: true,
        orderBy: "desc",
        // actionType: "default",
      },
    };
  },
  created() {
    this.pageTitle = this.$t('allsupplier');
    this.options.columns = [...this.options.columns, this.actionObj];
    this.searchAndSelectFilterOptions();
  },
  methods: {
    /**
     * for open add edit modal
     */
    previous() {
      this.pageTitle = this.$t('allsupplier');
      this.active = 1;
    },
    openFormModal() {
      this.isFormModalActive = true;
    },
    closeFormModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isFormModalActive = false;
      this.searchAndSelectFilterOptions();
    },

    /**
     * $emit Form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == this.$t("shortlist")) {
        // this.selectedUrl = `${actions.DATATABLE_DATA}/${rowData.id}`;
        this.userId = rowData.id;
        // this.openFormModal();
        this.supplierShortList();
      } else if (actionObj.title == this.$t("view_profile")) {
          this.view(rowData.id);
      }
    },
      view(id) {
         this.pageTitle = 'Supplier Profile';
          this.userId = id;
          this.active = 2;
        },
        myFunction(id){
            let doc = document.getElementById(id);
            if(doc){
                doc.addEventListener('click', () => {
                this.view(id);
            }); 
          }
        },
    supplierShortList() {
      axiosGet(actions.SUPPLIER_SHORTLIST+'/'+this.userId+'?role=Supplier')
        .then((res) => {
          this.$toastr.s(res.data.message);
        })
        .catch((res) => {
          this.$toastr.e(res.data.message);
        });
    },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit Form confirmation modal
     */
    confirmed() {
      let url = `${actions.DATATABLE_DATA}/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#demo-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(response.data.message);
          this.searchAndSelectFilterOptions();
        })
        .catch(({ error }) => {
          // Trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    /**
     * cancelled $emit Form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    searchAndSelectFilterOptions() {
      this.axiosGet(actions.ALL_SUPPLIERS_LIST).then((response) => {
        
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_and_select")
        );

       name.option = response.data.map((name) => {
          return {
            id: name.value,
            value: name.value,
          };
        });
      });
    },
  },
};
</script>
